<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEdicao ? 'Editar Rateio' : 'Novo Rateio' }}</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Preencha os dados abaixo para {{ isEdicao ? 'editar' : 'cadastrar' }} a configuração de
                            rateio.
                        </p>
                    </div>
                </div>
            </div>

            @if(isLoading) {
            <div class="col-12">
                <app-loading-box height="200"></app-loading-box>
            </div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">
                    <!-- Cabeçalho -->
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Nome</mat-label>
                                <input matInput formControlName="nome"
                                    placeholder="Digite o nome do rateio" maxlength="500" required>
                                @if (form.get('nome')?.hasError('required')) {
                                <mat-error>O nome é <strong>obrigatório</strong></mat-error>
                                }
                                @if (form.get('nome')?.hasError('maxlength')) {
                                <mat-error>O nome deve ter no máximo <strong>500 caracteres</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>                        
                    </div>

                    <div class="row">
                        <div class="col-md-12 col-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Descrição</mat-label>
                                <textarea matInput formControlName="descricao"
                                    placeholder="Descreva o propósito deste rateio (opcional)"
                                    maxlength="2000" rows="1"></textarea>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Grid de Rateio -->
                    <div class="rateio-section mt-3">
                        <div class="col-12 discount-grid" formArrayName="itens">

                            <div class="d-flex justify-content-between align-items-center mb-2 mt-4">
                                <p>Centros de Custo do Rateio</p>
                                <button type="button" mat-button (click)="adicionarLinha()">
                                    <mat-icon>add</mat-icon> Adicionar
                                </button>
                            </div>

                            @for (item of itensFormArray.controls; track $index; let i = $index) {
                            <div class="discount-row-wrapper" [formGroupName]="i">
                                <div class="row w-100 g-2 align-items-start m-0">
                                    <div class="col-6 col-lg-6">
                                        <mat-form-field appearance="outline" subscriptSizing="fixed"
                                            class="w-100 no-bottom-space compact-input">
                                            <mat-label>Centro de Custo</mat-label>
                                            <mat-select formControlName="idCentroCusto"
                                                placeholder="Selecione o centro de custo">
                                                @for (cc of centrosCustoDisponiveis(i); track cc.idCentroCusto) {
                                                <mat-option [value]="cc.idCentroCusto">
                                                    {{ cc.nome }}
                                                </mat-option>
                                                }
                                            </mat-select>
                                            @if (item.get('idCentroCusto')?.hasError('required') &&
                                            item.get('idCentroCusto')?.touched) {
                                            <mat-error>Selecione um centro de custo</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="col-4 col-lg-4">
                                        <mat-form-field appearance="outline" subscriptSizing="fixed"
                                            class="w-100 no-bottom-space compact-input">
                                            <mat-label>Percentual (%)</mat-label>
                                            <input matInput class="text-end" formControlName="percentual"
                                                currencyMask [options]="percentMask">
                                            @if (item.get('percentual')?.hasError('required') &&
                                            item.get('percentual')?.touched) {
                                            <mat-error>Obrigatório</mat-error>
                                            }
                                            @if (item.get('percentual')?.hasError('min')) {
                                            <mat-error>Valor não pode ser negativo</mat-error>
                                            }
                                            @if (item.get('percentual')?.hasError('max')) {
                                            <mat-error>Máximo 100%</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="col-2 col-lg-2 delete-col produto-grid-delete-col">
                                        <button type="button" mat-icon-button class="produto-grid-delete-button" (click)="removerLinha(i)"
                                            matTooltip="Remover">
                                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            }

                            @if (itensFormArray.length === 0) {
                            <div class="empty-state-grid">
                                Nenhum centro de custo adicionado.
                            </div>
                            }
                        </div>

                        <!-- Rodapé com soma e barra de progresso -->
                        @if (itensFormArray.length > 0) {
                        <app-percentual-progress-bar
                            [somaPercentual]="somaPercentual">
                        </app-percentual-progress-bar>
                        }
                    </div>
                </form>
            </div>
            }
        </div>
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>
